// extracted by mini-css-extract-plugin
export var product = "productSelect-module--product--3r7tO";
export var select = "productSelect-module--select--1My60";
export var btnsGroup = "productSelect-module--btns-group--3nX1B";
export var selectBtn = "productSelect-module--select-btn--2Z8ga";
export var active = "productSelect-module--active--2E1Cg";